import React from 'react';
import { Pagination } from '@uncinc/uncinc-react-kitchen-sink';

import './style.scss';

const Pager = (props) => {
  return (
    <Pagination
      {...props}
      previousLabel={<a className="Pagination__previous"><i className="icon icon-before icon-arrow-right icon-variant-2" />Vorige</a>}
      nextLabel={<a className="Pagination__next">Volgende<i className="icon icon-after icon-arrow-right icon-variant-2" /></a>}
    />
  );
};

export default Pager;
